import { createCustomOffsetsService } from '@shared/api'
import { authorizedHttpClient } from './http-client'

export const CustomOffsetsService = createCustomOffsetsService(authorizedHttpClient, import.meta.env.VITE_API_URL)
